<div class="modal-action" [ngStyle]="{ 'margin-top': isMobile ? '16px' : null, top: isMobile ? '7px' : null, 'padding-bottom': isMobile ? '8px' : null }">
	<div class="actions" *ngIf="!(typeReady || isRecording)" fxLayout="row">
		<button [disableRipple]="true" class="inner-right-button" (click)="closeModal.emit()" mat-fab-icon>
			<fa-icon icon="arrow-left"></fa-icon>
		</button>
	</div>
	<div class="actions" *ngIf="typeReady || isRecording" fxLayout="row" [@fadeIn]="typeReady || startAnimation ? '*' : 'void'">
		<div class="channel-image-container">
			<div class="channel-image-border">
				<img [alt]="channel?.name || notification.channel?.name" [src]="channel?.image?.url || notification.channel?.image?.url || 'assets/images/default.png'" class="channel-image" />
			</div>
		</div>
		<div #modalAction class="cta-container">
			<div fxLayout="row" class="cta-text" [style.width]="ctaWidth" [ngStyle]="getBackgroundColor()">
				<h3 class="cta">{{ notification.cta }}</h3>
			</div>
		</div>
	</div>
</div>
